const styles = {
  legend: {
    marginTop: '-2rem',
    paddingBottom: '2rem',
  },
};

export default styles;
